import axios from "axios";
import { baseURL } from "../../utils/URL";
 
const onInviteUsers = async ( postData:any ,config: any) => {
    try {
      const response = await axios.post(`${baseURL}/user/invite`, postData,config);
      return response.data;
    } catch (error: any) {
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }
  };
const onGetAllusers = async (config: any) => {
    try {
      const response = await axios.get(`${baseURL}/user/all`,config);
      return response.data;
    } catch (error: any) {
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }
  };
  
  const onGetUserByID= async (id:any ,config: any) => {
    try {
      const response = await axios.get(`${baseURL}/employee/${id}`,config);
      return response.data;
    } catch (error: any) {
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }
  };
  export{onInviteUsers,onGetUserByID, onGetAllusers}